import axios from "axios";
import Cookies from "js-cookie";
import { SPS_PATH_PREFIX } from "./constants";

const csrfToken = Cookies.get("csrftoken");

const getProject = async (projectId) => {
  const requestOptions = {
    method: "GET",
    url: `${SPS_PATH_PREFIX}/${projectId}`,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const createProject = async () => {
  const requestOptions = {
    method: "POST",
    url: `${SPS_PATH_PREFIX}/`,
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    data: {},
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const updateProject = async (projectId, body) => {
  const requestOptions = {
    method: "PATCH",
    url: `${SPS_PATH_PREFIX}/${projectId}/`,
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    data: body,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const uploadDocuments = async (formData) => {
  const requestOptions = {
    method: "POST",
    url: `${SPS_PATH_PREFIX}/document/`,
    headers: {
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": csrfToken,
    },
    data: formData,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const getDocumentsSps = async (projectId, documentId, viewType) => {
  const requestOptions = {
    method: "GET",
    url: `${SPS_PATH_PREFIX}/document/?sps_project_id=${projectId}&document_id=${documentId}&view_type=${viewType}`,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const deleteDocumentSps = async (documentId) => {
  const requestOptions = {
    method: "DELETE",
    url: `${SPS_PATH_PREFIX}/documents/${documentId}/`,
    headers: {
      "X-CSRFToken": csrfToken,
    },
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const addPrompt = async (body) => {
  const requestOptions = {
    method: "POST",
    url: `${SPS_PATH_PREFIX}/prompts/`,
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    data: body,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const indexDocument = async (body) => {
  const requestOptions = {
    method: "POST",
    url: `${SPS_PATH_PREFIX}/index/`,
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    data: body,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const promptRunSps = async (body) => {
  const requestOptions = {
    method: "POST",
    url: `${SPS_PATH_PREFIX}/prompt-run/`,
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    data: body,
  };

  return axios(requestOptions)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

export {
  getProject,
  createProject,
  updateProject,
  uploadDocuments,
  getDocumentsSps,
  deleteDocumentSps,
  addPrompt,
  indexDocument,
  promptRunSps,
};
